import moment from "moment";
import { createContext, useCallback, useContext, useState } from "react"
import { useSelector } from "react-redux";

const AssistancePlanContext = createContext({});

export const AssistancePlanContextProvider = ({ children }) => {
  const user = useSelector((state) => state.app?.user?.user)
  const [answers, setAnswers] = useState({});
  const [assistanceTitle, setAssistanceTitle] = useState("Registro de Atendimento")
  const [currentTab, setCurrentTab] = useState('open');
  const [assistanceLoadingTitle, setAssistanceLoadingTitle] = useState(true)
  const [savedStepsToRespond, setSavedStepsToRespond] = useState([])
  const [dataToUpdate, setDataToUpdate] = useState({
    technician: user.id,
  })
  const [selectedProject, setSelectedProject] = useState({})

  const handleChangeAnswer = (id, value, pinnedMessages, evidence) => {
    setAnswers(curr => ({ ...curr, [id]: value, [`${id}-messages`]: pinnedMessages }));
  }

  const handleChangeAssistanceTitle = (value) => {
    setAssistanceTitle(value)
    setAssistanceLoadingTitle(false)
  }

  const handleChangeDataToUpload = (name, { value }) => {

    if (value) {
      if (name === "dateToAdd") {
        let dateDifference = moment.utc(value, "DD/MM/YYYY")
        dateDifference = dateDifference.diff(moment.utc(), "days")

        /* if (dateDifference >= 1) {
          customToast("Você não pode selecionar uma data futura", "warning")
          return
        } */

        setDataToUpdate((curr) => ({
          ...curr,
          [name]: value ? moment.utc(value, "DD/MM/YYYY").format("YYYY-MM-DD") : moment.utc(Date.now()).format("YYYY-MM-DD"),
        }))
        return
      }

      setDataToUpdate((curr) => ({ ...curr, [name]: value }))
    }
    else {
      setDataToUpdate((curr) => ({ ...curr, [name]: {} }))
    }
  }

  const handleChangeSelectedProject = (field) => {
    setSelectedProject(field)
  }

  const handleChangeMessage = (id, messageId) => {
    const newMessageList = answers[`${id}-messages`].filter(msg => msg.id !== messageId);
    setAnswers(curr => ({ ...curr, [`${id}-messages`]: newMessageList }));
  }

  const handleChangeEvidence = (id, value) => {
    setAnswers(curr => ({ ...curr, [`${id}-evidence`]: value }));
  }

  const handleRemoveEvidence = (questionId, url) => {
    const newEvidenceList = answers[`${questionId}-evidence`].filter(evd => evd.url !== url);
    setAnswers(curr => ({ ...curr, [`${questionId}-evidence`]: newEvidenceList }));
  }

  const handleChangeTab = useCallback((newTab) => {
    setCurrentTab(newTab?.type);
  }, [])

  const resetAnswers = () => setAnswers({});

  const convertDefaultAnswers = (defaultAnswers = []) => {
    if (!defaultAnswers || !defaultAnswers.length) return;

    let formattedAnswers = {};
    defaultAnswers.map(answer => {
      formattedAnswers[`${answer.formQuestionId}-updatedId`] = answer.id;
      formattedAnswers[`${answer.formQuestionId}-messages`] = answer.messageIds || [];
      formattedAnswers[`${answer.formQuestionId}-evidence`] = answer.evidencesLinks || [];
      formattedAnswers[answer.formQuestionId] = answer.value.includes('|') ?
        answer.value.split('|').map(row => ({ value: row, label: row })) :
        ['text', 'number'].includes(answer.type) ? answer.value :
          { value: answer.value, label: answer.value };
    });

    setAnswers(formattedAnswers)
  }

  const resetAssistancePlanContext = () => {
    setSavedStepsToRespond([])
    resetAnswers()
    setDataToUpdate({})
    setAssistanceTitle("")
    setSelectedProject({})
  }

  return <AssistancePlanContext.Provider value={{
    answers,
    handleChangeAnswer,
    resetAnswers,
    convertDefaultAnswers,
    handleChangeMessage,
    handleChangeEvidence,
    setDataToUpdate,
    dataToUpdate,
    handleChangeDataToUpload,
    handleChangeSelectedProject,
    selectedProject,
    handleChangeAssistanceTitle,
    assistanceTitle,
    assistanceLoadingTitle,
    setAssistanceLoadingTitle,
    currentTab,
    handleChangeTab,
    savedStepsToRespond,
    setSavedStepsToRespond,
    resetAssistancePlanContext,
    handleRemoveEvidence
  }}
  >
    {children}
  </AssistancePlanContext.Provider>
}

export const useAssistancePlanContext = () => {
  return useContext(AssistancePlanContext);
}